import {BrowserModule, Meta, Title} from '@angular/platform-browser';
import {ErrorHandler, NgModule} from '@angular/core';

import {AppComponent} from './app.component';
import {AppRoutingModule} from './app-routing.module';
import {IconsProviderModule} from './icons-provider.module';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {NZ_I18N} from 'ng-zorro-antd/i18n';
import {en_US} from 'ng-zorro-antd/i18n';
import {LocationStrategy, PathLocationStrategy, registerLocaleData} from '@angular/common';
import en from '@angular/common/locales/en';
import {environment} from '@env';
import {LayoutModule} from './layout/layout.module';
import {CoreModule} from '@app/core.module';
import {ErrorInterceptor} from '@app/interceptor/error.interceptor';
import {SharedModule} from '@shared/shared.module';
import {TokenInterceptor} from '@app/interceptor/token.interceptor';
import {AuthModule} from '@modules/auth/auth.module';
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {NzLayoutModule} from 'ng-zorro-antd/layout';
import {ThemeConstantService} from '@shared/service/theme-constant/theme-constant.service';

import {SentryErrorService} from '@app/service/sentry-error/sentry-error.service';
import {WindowRef} from '@app/window-ref';
import {TimingInterceptor} from '@app/interceptor/timing.interceptor';
import {provideFirebaseApp} from '@angular/fire/app';
import {connectDatabaseEmulator, getDatabase, provideDatabase} from '@angular/fire/database';
import {ScreenTrackingService, UserTrackingService} from '@angular/fire/analytics';
import {getAnalytics, provideAnalytics} from '@angular/fire/analytics';
import {NgxsLoggerPluginModule} from '@ngxs/logger-plugin';
import {NgxsModule} from '@ngxs/store';
import {VehicleState} from '@shared/state/vehicle/vehicle.state';
import {UtilityState} from '@shared/state/utility/utility.state';
import {NgxsReduxDevtoolsPluginModule} from '@ngxs/devtools-plugin';
import {NgxsRouterPluginModule} from '@ngxs/router-plugin';
import {getApp, initializeApp} from '@firebase/app';

registerLocaleData(en);
initializeApp(environment.firebase);

// const isNode = typeof window === 'undefined';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    HttpClientModule,
    IconsProviderModule,

    provideFirebaseApp(() => getApp()),
    provideAnalytics(() => getAnalytics()),
    provideDatabase(() => {
      const database = getDatabase();
      if (environment.useEmulators) {
        connectDatabaseEmulator(database, 'localhost', 9001);
      }
      return database;
    }),
    NgxsLoggerPluginModule.forRoot({
      disabled: !environment.local
    }),
    NgxsModule.forRoot(
      [VehicleState, UtilityState],
      {developmentMode: environment.local}
    ),
    NgxsReduxDevtoolsPluginModule.forRoot({
      disabled: !environment.local
    }),
    NgxsRouterPluginModule.forRoot(),

    AppRoutingModule,

    CoreModule,
    AuthModule,
    LayoutModule,

    FontAwesomeModule,
    SharedModule,
    NzLayoutModule,
    BrowserModule.withServerTransition({appId: 'Carvry'})
  ],
  providers: [
    Meta,
    Title,
    {provide: NZ_I18N, useValue: en_US},
    {provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true},
    {provide: HTTP_INTERCEPTORS, useClass: TimingInterceptor, multi: true},
    {provide: LocationStrategy, useClass: PathLocationStrategy},
    ThemeConstantService,
    // Sentry Error Handler
    {provide: ErrorHandler, useClass: SentryErrorService},

    // Analytics Services
    ScreenTrackingService,
    UserTrackingService,
    WindowRef
  ]
})
export class AppModule {
}
